@if(showAdvanced()) {
    <mat-card class="export-config-card mt-3">
        <mat-card-header>
            <mat-card-title>Advanced Export Options</mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="config-grid">
                <!-- Nested Column Options -->
                <div class="config-section">
                    <h6>Nested Columns</h6>
                    <div class="form-group">
                        <label for="columnSeparatorInp">Column Separator</label>
                        <input pInputText 
                            id="columnSeparatorInp" 
                            [(ngModel)]="nestedSeparator"
                            (ngModelChange)="onConfigChange()"
                            placeholder=" - ">
                    </div>
                    <div class="form-group d-flex align-items-center align-content-center">
                        <p-checkbox id="flattenHeadersChk"
                            [(ngModel)]="flattenHeaders"
                            (onChange)="onConfigChange()"
                            binary="true"
                            label="Flatten nested headers">
                        </p-checkbox>
                        <label for="flattenHeadersChk" class="ms-2 my-0">Flatten nested headers</label>
                    </div>
                </div>

                <!-- Aggregate Labels -->
                <div class="config-section">
                    <h6>Aggregate Labels</h6>
                    <div class="label-inputs">
                        <div class="form-group">
                            <label for="totalLabelInput">Total Label</label>
                            <input pInputText 
                                id="totalLabelInput"
                                type="text"
                                [(ngModel)]="totalLabel"
                                (ngModelChange)="onLabelChange('sum', $event)"
                                placeholder="Total">
                        </div>
                        <div class="form-group">
                            <label for="avgLabelInput">Average Label</label>
                            <input pInputText 
                                id="avgLabelInput"
                                type="text"
                                [(ngModel)]="averageLabel"
                                (ngModelChange)="onLabelChange('avg', $event)"
                                placeholder="Average">
                        </div>
                        <div class="form-group">
                            <label for="countLabelInput">Count Label</label>
                            <input pInputText 
                                id="countLabelInput"
                                type="text"
                                [(ngModel)]="countLabel"
                                (ngModelChange)="onLabelChange('count', $event)"
                                placeholder="Count">
                        </div>
                    </div>
                </div>

                <!-- Export Format Options -->
                <div class="config-section">
                    <h6>Format Options</h6>
                    <div class="form-group d-flex align-items-center align-content-center text-center">
                        <p-checkbox id="separatorRowChk"
                            [(ngModel)]="separatorRow"
                            (onChange)="onConfigChange()"
                            binary="true"
                            label="Add separator row for aggregates">
                        </p-checkbox>
                        <label for="separatorRowChk" class="ms-2 my-0">Add separator row for aggregates</label>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
}